import { inject, Injectable }                                                        from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable }                                                                from 'rxjs';
import { map }                                                                       from 'rxjs/operators';
import { SessionService }                                                            from '../../../api/session/session.service';
import { InternalRoutes }                                                            from '../../../shared/data/internal-routes';

@Injectable({
  providedIn: 'root'
})
export class NotSsoUserGuard implements CanActivate {
  private router = inject(Router);
  private sessionService = inject(SessionService);

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.userIsNotSso();
  }

  private userIsNotSso(): Observable<boolean | UrlTree> {
    return this.sessionService.loadSession().pipe(map(
      sessionData => (!sessionData.sso) ? true : this.router.parseUrl(InternalRoutes.ERROR)
    ));
  }
}
